import React, { useEffect, useState } from 'react';
import renderIf from 'render-if';
import styles from './FlagRecordButton.module.css';
import flagRecord from './flagRecordHelper';
import classNames from 'classnames';
import AhaAnalytics from 'javascripts/analytics';

export default function FlagRecordButton({
  recordId,
  recordType,
  manualRiskComment,
}) {
  const [loading, setLoading] = useState(false);
  const hasComment = manualRiskComment !== null;
  const text = hasComment ? 'Remove flag' : 'Flag record';
  const icon =
    'fa-regular ' + (hasComment ? 'fa-trash-can' : 'fa-exclamation-triangle');

  const toggleFlag = () => {
    if (loading) return;
    setLoading(true);

    AhaAnalytics.track(
      'Feature-7148130073796750739',
      'User manually flags record',
      {
        'Workspace type': window?.currentWorkspaceType,
        'Record type': recordType,
        // This looks the wrong way around, but hasComment is the current status
        // so it will be the opposite of that after this function runs.
        Status: hasComment ? 'disabled' : 'enabled',
      }
    );

    flagRecord(recordType, recordId, hasComment ? null : '');
  };

  useEffect(() => setLoading(false), [manualRiskComment]);

  return (
    <div
      className={classNames(styles.flagRecordButton, {
        [styles.loading]: loading,
      })}
    >
      {renderIf(loading)(() => (
        <aha-spinner track />
      ))}
      <aha-button
        class='attribute__control'
        disabled={loading || null}
        onClick={() => toggleFlag()}
      >
        <i className={icon} /> {text}
      </aha-button>
    </div>
  );
}
